export default __webpack_public_path__ + "static/ignite-loading-screen-f891f404ca17a05395cdb4ab29babe53.jpg";